var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconThreedots = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 5,
    viewBox: "0 0 16 5",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.689453C0.9 0.689453 0 1.65152 0 2.82738C0 4.00325 0.9 4.96532 2 4.96532C3.1 4.96532 4 4.00325 4 2.82738C4 1.65152 3.1 0.689453 2 0.689453Z",
    fill: "#606474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.689453C12.9 0.689453 12 1.65152 12 2.82738C12 4.00325 12.9 4.96532 14 4.96532C15.1 4.96532 16 4.00325 16 2.82738C16 1.65152 15.1 0.689453 14 0.689453Z",
    fill: "#606474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.82738C6 1.65152 6.9 0.689453 8 0.689453C9.1 0.689453 10 1.65152 10 2.82738C10 4.00325 9.1 4.96532 8 4.96532C6.9 4.96532 6 4.00325 6 2.82738Z",
    fill: "#606474"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconThreedots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-threedots.2d747c45.svg";
export { ForwardRef as ReactComponent };